/* ==========================================================================
   Product LNT — JS
   - Lightbox (ouvrir/fermer, navigation clavier, flèches, swipe, dots)
   - Quantité (+ / −)
   - Bouton partage (navigator.share ou copie URL)
   - Slider mobile galerie (flèches, dots, sync sur scroll)
   ========================================================================== */

(function () {
  "use strict";

  document.querySelectorAll(".product-lnt").forEach(initProductLnt);

  function initProductLnt(section) {
    initQuantity(section);
    initLightbox(section);
    initShare(section);
    initMobileSlider(section);
    initVideoLightbox(section);
  }

  /* ------------------------------------------------------------------ */
  /* QUANTITÉ                                                            */
  /* ------------------------------------------------------------------ */
  function initQuantity(section) {
    const input = section.querySelector(".product-lnt__qty-input");
    const decrease = section.querySelector("[data-qty-decrease]");
    const increase = section.querySelector("[data-qty-increase]");

    if (!input || !decrease || !increase) return;

    decrease.addEventListener("click", function () {
      const current = parseInt(input.value, 10) || 1;
      if (current > 1) input.value = current - 1;
    });

    increase.addEventListener("click", function () {
      const current = parseInt(input.value, 10) || 1;
      input.value = current + 1;
    });
  }

  /* ------------------------------------------------------------------ */
  /* LIGHTBOX                                                            */
  /* ------------------------------------------------------------------ */
  function initLightbox(section) {
    const lightbox = section.querySelector("[data-lightbox]");
    const inner = section.querySelector("[data-lightbox-inner]");
    const counter = section.querySelector("[data-lightbox-counter]");
    const closeBtn = section.querySelector("[data-lightbox-close]");
    const prevBtn = section.querySelector("[data-lightbox-prev]");
    const nextBtn = section.querySelector("[data-lightbox-next]");
    const dataScript = section.querySelector("[data-lightbox-data]");

    if (!lightbox || !inner || !dataScript) return;

    let images = [];
    try {
      images = JSON.parse(dataScript.textContent.trim()) || [];
    } catch (e) {
      console.warn("[product-lnt] Lightbox JSON invalide", e);
      return;
    }

    if (images.length === 0) return;

    let currentIndex = 0;
    const preloadedImages = new Array(images.length).fill(null);

    function preloadImage(index) {
      if (preloadedImages[index] || !images[index])
        return preloadedImages[index];
      const img = new Image();
      img.src = images[index].src;
      img.alt = images[index].alt || "";
      if (images[index].width) img.setAttribute("width", images[index].width);
      if (images[index].height)
        img.setAttribute("height", images[index].height);
      preloadedImages[index] = img;
      return img;
    }

    function preloadAll() {
      images.forEach(function (_, index) {
        preloadImage(index);
      });
    }

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(preloadAll, { timeout: 2000 });
    } else {
      setTimeout(preloadAll, 500);
    }

    function render() {
      const preloaded = preloadImage(currentIndex);
      inner.innerHTML = "";
      const el = preloaded.cloneNode(true);
      inner.appendChild(el);

      if (counter) {
        counter.textContent = currentIndex + 1 + " / " + images.length;
      }

      const hasMultiple = images.length > 1;
      if (prevBtn) prevBtn.style.display = hasMultiple ? "" : "none";
      if (nextBtn) nextBtn.style.display = hasMultiple ? "" : "none";
      if (counter) counter.style.display = hasMultiple ? "" : "none";

      if (hasMultiple) {
        const nextIdx = (currentIndex + 1) % images.length;
        const prevIdx = (currentIndex - 1 + images.length) % images.length;
        preloadImage(nextIdx);
        preloadImage(prevIdx);
      }
    }

    function open(index) {
      currentIndex = Math.max(0, Math.min(index, images.length - 1));
      render();
      lightbox.hidden = false;
      lightbox.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      lightbox.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      inner.innerHTML = "";
    }

    function next() {
      currentIndex = (currentIndex + 1) % images.length;
      render();
    }

    function prev() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      render();
    }

    section.querySelectorAll("[data-lightbox-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const mediaId = btn.getAttribute("data-media-id");
        let index = 0;
        if (mediaId) {
          const found = images.findIndex(function (img) {
            return String(img.id) === String(mediaId);
          });
          if (found >= 0) index = found;
        } else {
          const fallback = btn.getAttribute("data-lightbox-index");
          if (fallback !== null) index = parseInt(fallback, 10) || 0;
        }
        open(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener("click", close);
    if (prevBtn)
      prevBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        prev();
      });
    if (nextBtn)
      nextBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        next();
      });

    lightbox.addEventListener("click", function (e) {
      if (
        e.target.closest("[data-lightbox-close]") ||
        e.target.closest("[data-lightbox-prev]") ||
        e.target.closest("[data-lightbox-next]")
      ) {
        return;
      }
      if (e.target.tagName === "IMG") {
        return;
      }
      close();
    });

    document.addEventListener("keydown", function (e) {
      if (lightbox.hidden) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "ArrowLeft") prev();
    });

    let touchStartX = 0;
    let touchEndX = 0;
    inner.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true },
    );
    inner.addEventListener(
      "touchend",
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) prev();
          else next();
        }
      },
      { passive: true },
    );
  }

  /* ------------------------------------------------------------------ */
  /* PARTAGE                                                             */
  /* ------------------------------------------------------------------ */
  function initShare(section) {
    const btn = section.querySelector("[data-share-btn]");
    if (!btn) return;

    btn.addEventListener("click", async function () {
      const url = btn.getAttribute("data-share-url") || window.location.href;
      const title = btn.getAttribute("data-share-title") || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title: title, url: url });
        } catch (e) {
          // user cancelled — silent
        }
      } else if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(url);
          const originalText = btn.querySelector("span").textContent;
          btn.querySelector("span").textContent = "Lien copié !";
          setTimeout(function () {
            btn.querySelector("span").textContent = originalText;
          }, 2000);
        } catch (e) {
          console.warn("[product-lnt] Impossible de copier", e);
        }
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* SLIDER MOBILE GALERIE                                               */
  /* ------------------------------------------------------------------ */
  function initMobileSlider(section) {
    const wrap = section.querySelector("[data-product-slider]");
    if (!wrap) return;

    const track = wrap.querySelector("[data-slider-track]");
    const prevBtn = wrap.querySelector("[data-slider-prev]");
    const nextBtn = wrap.querySelector("[data-slider-next]");
    const dots = Array.from(wrap.querySelectorAll("[data-slider-dot]"));
    const slides = Array.from(track.querySelectorAll(".product-lnt__slide"));

    if (slides.length === 0) return;

    /**
     * Renvoie l'index de la slide la plus proche du centre du track.
     * Cette fonction est utilisée à la fois pour mettre à jour le dot actif
     * pendant le scroll, et pour calculer où aller en cliquant prev/next.
     */
    function getCurrentIndex() {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach(function (slide, i) {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      return closestIndex;
    }

    function scrollToSlide(index) {
      const target = slides[index];
      if (!target) return;

      const trackRect = track.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      // Position du centre de la slide cible relative au track
      const targetCenter =
        target.offsetLeft + target.offsetWidth / 2;
      const desiredScrollLeft = targetCenter - trackRect.width / 2;

      track.scrollTo({
        left: desiredScrollLeft,
        behavior: "smooth",
      });
    }

    function updateUI() {
      const currentIndex = getCurrentIndex();

      // Dots
      dots.forEach(function (dot, i) {
        if (i === currentIndex) {
          dot.classList.add("is-active");
        } else {
          dot.classList.remove("is-active");
        }
      });

      // Flèches : cacher prev au début, next à la fin
      if (prevBtn) {
        if (currentIndex === 0) {
          prevBtn.setAttribute("hidden", "");
        } else {
          prevBtn.removeAttribute("hidden");
        }
      }

      if (nextBtn) {
        if (currentIndex >= slides.length - 1) {
          nextBtn.setAttribute("hidden", "");
        } else {
          nextBtn.removeAttribute("hidden");
        }
      }
    }

    // Click flèches
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        const currentIndex = getCurrentIndex();
        scrollToSlide(Math.max(0, currentIndex - 1));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        const currentIndex = getCurrentIndex();
        scrollToSlide(Math.min(slides.length - 1, currentIndex + 1));
      });
    }

    // Click dots
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        const targetIndex = parseInt(dot.getAttribute("data-slider-dot"), 10);
        if (!isNaN(targetIndex)) {
          scrollToSlide(targetIndex);
        }
      });
    });

    // Mise à jour pendant le scroll (throttle via rAF)
    let scrollRaf = null;
    track.addEventListener(
      "scroll",
      function () {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateUI);
      },
      { passive: true },
    );

    // Mise à jour aussi au resize (au cas où le breakpoint passe ou les
    // dimensions changent, ce qui peut affecter le calcul de currentIndex)
    let resizeRaf = null;
    window.addEventListener("resize", function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(updateUI);
    });

    // Initial state
    updateUI();
  }

  /* ------------------------------------------------------------------ */
  /* LIGHTBOX VIDÉO                                                      */
  /* ------------------------------------------------------------------ */
  function initVideoLightbox(section) {
    const lightbox = section.querySelector("[data-video-lightbox]");
    const inner = section.querySelector("[data-video-lightbox-inner]");
    const closeBtn = section.querySelector("[data-video-lightbox-close]");
    const triggers = section.querySelectorAll("[data-product-video]");

    if (!lightbox || !inner || triggers.length === 0) return;

    /**
     * Extrait l'ID YouTube depuis une URL (formats supportés : watch?v=, youtu.be/, embed/)
     */
    function getYouTubeId(url) {
      const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
      ];
      for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) return match[1];
      }
      return null;
    }

    /**
     * Extrait l'ID Vimeo depuis une URL
     */
    function getVimeoId(url) {
      const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return match ? match[1] : null;
    }

    function open(url, type) {
      inner.innerHTML = "";

      let element;

      if (type === "youtube") {
        const ytId = getYouTubeId(url);
        if (!ytId) {
          console.warn("[product-lnt] URL YouTube invalide:", url);
          return;
        }
        element = document.createElement("iframe");
        // enablejsapi=1 permet de contrôler le player après chargement (volume).
        // YouTube ne supporte pas un volume initial via URL — il faut passer
        // par postMessage une fois l'iframe prête.
        element.src =
          "https://www.youtube.com/embed/" +
          ytId +
          "?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1";
        element.setAttribute("allow", "autoplay; encrypted-media; fullscreen");
        element.setAttribute("allowfullscreen", "");

        // Régler le volume YouTube à 50% une fois l'iframe chargée
        element.addEventListener("load", function () {
          // Petit délai pour laisser le player s'initialiser complètement
          setTimeout(function () {
            try {
              element.contentWindow.postMessage(
                JSON.stringify({
                  event: "command",
                  func: "setVolume",
                  args: [50],
                }),
                "*",
              );
            } catch (e) {
              // Cross-origin peut bloquer dans certains cas, c'est ok
            }
          }, 500);
        });
      } else if (type === "vimeo") {
        const vimeoId = getVimeoId(url);
        if (!vimeoId) {
          console.warn("[product-lnt] URL Vimeo invalide:", url);
          return;
        }
        element = document.createElement("iframe");
        element.src =
          "https://player.vimeo.com/video/" +
          vimeoId +
          "?autoplay=1&dnt=1&playsinline=1";
        element.setAttribute("allow", "autoplay; fullscreen");
        element.setAttribute("allowfullscreen", "");

        // Vimeo : volume contrôlable via postMessage Player API
        element.addEventListener("load", function () {
          setTimeout(function () {
            try {
              element.contentWindow.postMessage(
                JSON.stringify({ method: "setVolume", value: 0.5 }),
                "*",
              );
            } catch (e) {
              // silent
            }
          }, 500);
        });
      } else {
        // MP4 direct (URL externe ou fichier Shopify)
        // Pour les vidéos natives, le volume est réglable directement.
        element = document.createElement("video");
        element.src = url;
        element.controls = true;
        element.autoplay = true;
        element.playsInline = true;
        element.volume = 0.5; // 50% par défaut
      }

      inner.appendChild(element);
      lightbox.hidden = false;
      lightbox.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      lightbox.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      // Vider le DOM stoppe la lecture (sinon YouTube continue de jouer en fond)
      inner.innerHTML = "";
    }

    triggers.forEach(function (btn) {
      btn.addEventListener("click", function () {
        const url = btn.getAttribute("data-video-url");
        const type = btn.getAttribute("data-video-type");
        if (url && type) {
          open(url, type);
        }
      });
    });

    if (closeBtn) closeBtn.addEventListener("click", close);

    // Click backdrop ferme (mais pas si on clique dans la zone vidéo)
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) {
        close();
      }
    });

    // Échap ferme
    document.addEventListener("keydown", function (e) {
      if (lightbox.hidden) return;
      if (e.key === "Escape") close();
    });
  }
})();